import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDistributionInsight = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [distributionInsightData, setDistributionInsightData] = useState<DistributionInsightDataInterface | null>(null);

    const onDistributionDataError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error('Error fetching distribution insight data:', err);
    };

    const onDistributionDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<DistributionInsightDataInterface>) => {
        setDistributionInsightData(data);
    };

    const getDistributionDataInsight = (driverId: string, companyId: string) => {
        const url: HttpConfig = {
            url: `ba/v1/drivers/${driverId}/metrics?companyId=${companyId}&isLookup=false`,
            method: 'get',

        };
        request(url, onDistributionDataSuccess, setLoading, onDistributionDataError);
    };

    return { getDistributionDataInsight, loading, distributionInsightData };
};

export default useDistributionInsight;


interface DistributionInsightDataInterface {
    logiScore: number;
    baseline: number;
    difference: number;
    incidentDistribution: {
        theftReports: number;
        accidentReports: number;
        totalReports: number;
        avgTheftSeverity: number;
        avgAccidentSeverity: number;
        reportRate: number;
    };
}
